import styled, { css, keyframes } from 'styled-components';
import { Col as ColAnt } from 'antd';
import { Wrapper as Form } from 'v3/components/SidebarBox/styles';
import { Wrapper as Signature } from 'v3/components/Signature/styles';
import {
  Container as MinimalBanner,
  Text,
  Description,
} from 'v3/components/MinimalBanner/styles';
import { SpinnerIos } from '@styled-icons/fluentui-system-regular/SpinnerIos';
import { Wrapper as PaymentMethodButton } from 'components/PaymentMethod/styles';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    @media (max-width: 992px) {
      ${Form} {
        padding: 0;
        border: none;
        background-color: ${theme.colors.neutralSilver5};
      }
    }
  `}
`;

export const Badge = styled.span`
  ${({ theme }) => css`
    display: inline-table;
    border-radius: 12px;
    padding: 5px 10px;
    font-size: 1.4rem;
    font-weight: 500;
    color: ${theme.colors.globalBlack};
    background-color: ${theme.colors.primary20};
    line-height: 1.6rem;
  `}
`;

export const Paragraph = styled.p`
  ${({ theme }) => css`
    font-size: 1.5rem;
    color: ${theme.colors.neutralSilver80};
    line-height: 2rem;
    margin: 2rem 0;
  `}
`;

export const TitleCol = styled(ColAnt)`
  @media (max-width: 1200px) {
    margin: 0;
  }
`;

export const Col = styled(ColAnt)`
  margin: 20px 0;
  max-width: 700px;
`;

export const OfferCol = styled(ColAnt)`
  position: sticky;
  top: 24px;
  align-self: start;

  @media (max-width: 992px) {
    position: static;
  }
`;

export const TitleSection = styled.section`
  margin-bottom: 40px;
`;

export const OfferSection = styled.div`
  @media (max-width: 992px) {
    margin-bottom: 32px;
  }
`;

export const OfferTitle = styled.h3`
  ${({ theme }) => css`
    font-size: 2.4rem;
    font-weight: 700;
    color: ${theme.colors.neutralSilver90};
    margin-bottom: 16px;
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    font-size: 3.2rem;
    line-height: 3.8rem;
    font-weight: 600;
    color: ${theme.colors.neutralSilver80};
    margin: 32px 0;

    @media (max-width: 992px) {
      font-size: 2.4rem;
      line-height: 1.23;
      margin-bottom: 24px;
    }

    @media (max-width: 840px) {
      margin-left: 16px;
    }
  `}
`;

export const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding-bottom: 20px;
`;

export const SectionTitle = styled.h3`
  ${({ theme }) => css`
    font-size: 2rem;
    font-weight: 600;
    color: ${theme.colors.neutralSilver70};
    margin-bottom: 32px;

    @media (max-width: 992px) {
      margin-bottom: 16px;
    }
  `}
`;

export const SectionTitleCompact = styled(SectionTitle)`
  ${({ theme }) => css`
    margin-bottom: 8px;
  `}
`;


export const MembershipSection = styled.div`
  margin-bottom: 32px;
`;

export const MobileSection = styled.div`
  ${({ theme }) => css`
    @media (max-width: 992px) {
      background-color: ${theme.colors.globalWhite100};
      border: 1px solid ${theme.colors.neutralSilver10};
      width: 100%;
      border-radius: 16px;
      padding: 32px 16px;
      box-shadow: none;
      margin-bottom: 24px;
    }
  `}
`;

export const ContractAgreementSection = styled.div`
  margin-bottom: 32px;
`;

export const SignatureSection = styled.div`
  margin-bottom: 32px;

  @media (max-width: 992px) {
    margin-bottom: 0;

    ${Signature} {
      border-bottom: 0;
      padding-bottom: 0;
    }
  }
`;

export const SignatureDescription = styled.p`
  ${({ theme }) => css`
    font-size: 1.2rem;
    color: ${theme.colors.neutralSilver80};
    line-height: 1.6;
  `}
`;

export const PaymentMethodSection = styled.div`
  ${({ theme }) => css`
    margin-bottom: 32px;

    @media (max-width: 992px) {
      background-color: ${theme.colors.globalWhite100};
      padding: 32px 16px;
      border: 1px solid ${theme.colors.neutralSilver10};
      border-radius: 16px;
    }
  `}
`;

export const LearnPlaid = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;

  a {
    margin-left: 20px;
  }
`;

export const PlaidName = styled.p`
  ${({ theme }) => css`
    font-size: 2rem;
    font-weight: 500;
    color: ${theme.colors.globalBlack};
    line-height: 1.4;
    margin-right: 8px;
  `}
`;

export const PlaidDescription = styled.p`
  ${({ theme }) => css`
    font-size: 1.8rem;
    color: ${theme.colors.neutralSilver90};
    line-height: 1.6;
    margin-bottom: 20px;

    @media (max-width: 992px) {
      font-size: 1.6rem;
    }
  `}
`;

export const PaymentDetails = styled.div``;

export const PaymentItem = styled.div``;

export const PaymentDetailTitle = styled.h4`
  ${({ theme }) => css`
    font-size: 1.6rem;
    font-weight: 400;
    color: ${theme.colors.neutralSilver60};
    line-height: 1.6;
    margin-bottom: 4px;

    > strong {
      font-weight: 500;
      color: ${theme.colors.neutralSilver80};
    }
  `}
`;

export const PaymentDetailDescription = styled.p`
  ${({ theme }) => css`
    font-size: 1.6rem;
    font-weight: 500;
    color: ${theme.colors.neutralSilver80};
    line-height: 1.6;
    margin-bottom: 24px;

    > span {
      color: ${theme.colors.brandPrimary70};
    }

    > div {
      display: inline;
      font-size: 1.4rem;
      font-weight: 400;
      color: ${theme.colors.neutralSilver60};

      @media (max-width: 576px) {
        display: block;
      }
    }
  `}
`;

export const PaymentDetailFirstDescription = styled.p`
  ${({ theme }) => css`
    display: inline;
    font-size: 1.4rem;
    font-weight: 400;
    color: ${theme.colors.neutralSilver60};
  `}
`;

export const PaymentDetailSpecs = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 16px;
  margin: 20px 0 32px 0;

  @media (max-width: 610px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 45px;
    row-gap: 16px;
  }
`;

export const PaymentDetailSpecsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.5fr 1fr;
  align-items: center;
  gap: 16px;
  margin: 20px 0 32px 0;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const PaymentObs = styled.span`
  ${({ theme }) => css`
    font-size: 1.4rem;
    font-style: italic;
    color: ${theme.colors.neutralSilver70};
    line-height: 1.6;
    display: block;
    margin-bottom: 32px;
  `}
`;

export const Checkboxes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 32px;

  a {
    font-size: 1.6rem;
    line-height: 1;
  }
`;

export const FieldWrapper = styled.div``;

export const ButtonSection = styled.div`
  button {
    display: flex;
    justify-content: center;
    min-width: 180px;
  }
`;

export const ErrorMessage = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 14px;

    p {
      font-size: 1.4rem;
      line-height: 1.6rem;
      /* statusDanger40 rather than 30: this sits on the white card, where the
         deeper red reads unambiguously red and lifts contrast to 5.43:1. */
      color: ${theme.colors.statusDanger40};
      font-weight: 500;
    }
  `}
`;

export const Buttons = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 24px;

    > a {
      color: ${theme.colors.brandPrimary70};
      border-bottom-color: ${theme.colors.brandPrimary70};
    }

    > button {
      min-width: 272px;

      display: flex;
      align-items: center;
      justify-content: center;
    }

    @media (max-width: 576px) {
      flex-direction: column;
      align-items: center;

      > a {
        order: 2;
      }

      > button {
        display: flex;
        justify-content: center;
        width: 100%;
        order: 1;
      }
    }
  `}
`;

export const EncryptContent = styled.div`
  ${({ theme }) => css`
    border-top: 1px solid ${theme.colors.neutralSilver20};
    border-bottom: 1px solid ${theme.colors.neutralSilver20};
    padding: 20px 0;
    margin-bottom: 24px;
    display: flex;
    justify-content: center;

    @media (max-width: 992px) {
      margin-top: 16px;
    }
  `}
`;

export const LockText = styled.span`
  ${({ theme }) => css`
    font-size: 1.2rem;
    font-style: italic;
    color: ${theme.colors.neutralGray60};
    line-height: 1.6;
  `}
`;

export const PromotionalModalContent = styled.div`
  ${({ theme }) => css`
    p {
      font-size: 1.4rem;
      line-height: 2.2rem;
      margin-bottom: 12px;

      color: ${theme.colors.neutralSilver80};

      strong {
        font-weight: 700;
      }

      @media (max-width: 500px) {
        font-size: 1.2rem;
        line-height: 1.8rem;
      }
    }

    > div {
      display: flex;
      gap: 4px;
      font-size: 1.2rem;
      line-height: 1.8rem;
      color: ${theme.colors.brandPrimary70};
      font-weight: 500;

      a:hover {
        color: ${theme.colors.brandPrimary70};
      }
    }
  `}
`;

export const DesktopOnly = styled.div`
  display: block;

  @media (max-width: 992px) {
    display: none;
  }
`;

export const MobileOnly = styled.div`
  display: none;

  @media (max-width: 992px) {
    display: block;
  }
`;

export const PaymentMethodChildren = styled.div`
  ${({ theme }) => css`
    margin-top: 24px;

    ${MinimalBanner} {
      background-color: ${theme.colors.neutralSilver5};
      border: 0;
    }

    ${Text} {
      font-size: 1.8rem;
      margin-bottom: 12px;
    }

    ${Description} {
      p {
        font-size: 1.6rem;
        line-height: 1.4;
      }
    }

    @media (max-width: 992px) {
      padding: 0 16px 16px 16px;

      ${Text} {
        font-size: 1.4rem;
        margin-bottom: 4px;
      }

      ${Description} {
        p {
          font-size: 1.2rem;
          line-height: 1.4;
        }
      }
    }
  `}
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const ProcessingIcon = styled(SpinnerIos)`
  animation: 2s linear ${spin} infinite;
  margin-left: 8px;
`;

export const PaymentMethodSelection = styled.div`
  display: flex;
  gap: 24px;

  @media (max-width: 500px) {
    justify-content: space-between;
  }

  ${PaymentMethodButton} {
    max-width: 200px;
    width: 100%;
    cursor: pointer;
  }
`;

export const ChoosePaymentMethodSection = styled.div`
  margin-bottom: 24px;
`;

export const ButtonWrapper = styled.div`
  margin-top: 24px;
`;

export const ChoosePaymentMethodWrapper = styled.div`
  margin-top: 24px;
  position: relative;
`;

export const P = styled.p`
  ${({ theme }) => css`
    font-size: 1.4rem;
    color: ${theme.colors.neutralSilver80};
    line-height: 1.6;

  `}
`;

export const CardElementWrapper = styled.div`
  max-width: 800px;
  width: 100%;
  border: 1px solid rgb(209, 214, 224);
  border-radius: 8px;
  padding: 0 7px;
`;

export const CCSubmitButton = styled.button`
  ${({ theme }) => css`
    margin-top: 24px;

    padding: 8px 16px;
    font-size: 1.6rem;
    background-color: ${theme.colors.brandPrimary70};
    border: none;
    color: ${theme.colors.globalWhite100};

    &:hover {
      background-color: ${theme.colors.purple80};
      color: ${theme.colors.globalWhite100};
    }

    &:active,
    &:focus {
      outline: 2px solid ${theme.colors.brandPrimary30};
      outline-offset: 1px;
    }

    border-radius: 4px;
    font-weight: 500;
    line-height: 1.6;
    display: inline-flex;
    align-items: center;
    text-decoration: none;
    cursor: pointer;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    // > span {
    //   margin-right: 8px;
    // }
  `}
`;

export const SuccessContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 6rem 2rem;
    text-align: center;
    min-height: 400px;
  `}
`;

export const SuccessIcon = styled.div`
  margin-bottom: 2rem;
  animation: scaleIn 0.5s ease-out;

  @keyframes scaleIn {
    from {
      transform: scale(0);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }
`;

export const SuccessTitle = styled.h1`
  ${({ theme }) => css`
    font-size: 3.2rem;
    font-weight: 700;
    color: ${theme.colors.neutralSilver90};
    margin-bottom: 1.6rem;
    line-height: 1.2;

    @media (max-width: 768px) {
      font-size: 2.4rem;
    }
  `}
`;

export const SuccessMessage = styled.p`
  ${({ theme }) => css`
    font-size: 1.8rem;
    color: ${theme.colors.neutralSilver70};
    line-height: 1.6;
    max-width: 500px;
    margin-bottom: 1.6rem;

    @media (max-width: 768px) {
      font-size: 1.6rem;
    }
  `}
`;

export const SuccessNote = styled.p`
  ${({ theme }) => css`
    font-size: 1.4rem;
    color: ${theme.colors.neutralSilver60};
    font-style: italic;
    margin-top: 2rem;
  `}
`;

/* The unsupported-brand notice under the card field.
   Its own styled <p> rather than a <p> inside ErrorMessage: global.scss declares a
   bare `p { color: #797979 }`, and keeping the colour on this element's own class
   means no descendant-selector specificity race decides whether it renders red.
   Layout's white card: deeper red, 5.43:1. */
export const UnsupportedBrandMessage = styled.p`
  margin-top: 12px;
  font-size: 1.4rem;
  line-height: 1.6rem;
  font-weight: 500;
  color: #C92B2B;
`;
